import { render, staticRenderFns } from "./SelectForm.vue?vue&type=template&id=950b7442&scoped=true&"
import script from "./SelectForm.vue?vue&type=script&lang=js&"
export * from "./SelectForm.vue?vue&type=script&lang=js&"
import style0 from "./SelectForm.vue?vue&type=style&index=0&id=950b7442&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950b7442",
  null
  
)

export default component.exports